

import { Button, InputBase, MenuItem, Typography, alpha, Chip, Box, FormControl, Select, CircularProgress, TablePagination, Autocomplete, TextField, IconButton, Tooltip, Stack } from "@mui/material";
import React, { useState, useEffect, useMemo } from 'react';
import "./BFacturation.scss";
import { AccountBoxSharp, AirplaneTicket, ArrowBack, Business, MonetizationOnSharp, Refresh, People, Download, Delete } from "@mui/icons-material";
import { COLORS, output, priceFormatterV3, dateFormatter } from "../../settings/themeSettings";
import useIsAdmin from '../../hooks/useIsAdmin';
import styled from "@emotion/styled";
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate, useParams } from "react-router";
import StyledTable from "../../components/table-component/StyledTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchFactures } from "../../data/slices/factureSlice";
import { filtrerParType } from "../../data/slices/factureSlice";
import { creditAccount, fetchClient, fetchClients } from "../../data/slices/clientStore";
import CreditDialog from "../../components/CreditDialog";
import { notify } from "../../settings/toastSetting";
import { fetchClientDevis } from "../../data/slices/devisSlice";
import api from '../../config/axiosConfig';
import { BaseURL } from "../../settings/APISetting";
import facturationService from '../../services/facturationService';


const head = ['numeroFacture', 'numeroDossier', 'commentaire', 'date', 'type_facture', 'statut', 'actions'];

const typesFacture = [
    { value: 'ALL',          label: 'Tous les types' },
    { value: 'BILLETTERIE',  label: 'Billetterie' },
    { value: 'BILLET_AVION', label: 'Billets d\'avion' },
    { value: 'MODIFICATION', label: 'Modification' },
    { value: 'ASSURANCE',    label: 'Assurance' },
    { value: 'ATTESTATION',  label: 'Attestation' },
    { value: 'AUTRE',        label: 'Autre' },
];

const statutsFacture = [
    { value: 'ALL', label: 'Tous les statuts' },
    { value: 'PAYEE', label: 'Payée' },
    { value: 'IMPAYEE', label: 'Impayée' },
    { value: 'PARTIEL', label: 'Partiellement payée' },
    { value: 'ANNULLEE', label: 'Annulée' }
];


export const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(COLORS.tertiary, 0.15),
    '&:hover': {
        backgroundColor: alpha(COLORS.tertiary, 0.25),
    },

    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

export const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: COLORS.secondary,
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%'
    },
}));







const BFacturation = (props) => {

    const navigateTo = useNavigate();
    const isAdmin = useIsAdmin();

    const { factures, fetchStatus } = useSelector((state) => state.factures);
    const { devisList } = useSelector((state) => state.devis);
    const { clients, fetchStatus: clientsFetchStatus } = useSelector((state) => state.clients);
    const dispatch = useDispatch();
    const { clientId } = useParams();
    const [currentClient, setCurrentClient] = useState({});

    const [open, setOpen] = useState(false);
    const [tab, setTab] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [typeFilter, setTypeFilter] = useState('ALL');
    const [statutFilter, setStatutFilter] = useState('ALL');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [numberingStats, setNumberingStats] = useState(null);
    const [loadingStats, setLoadingStats] = useState(false);
    const [clientSearchTerm, setClientSearchTerm] = useState('');

    const openDialog = () => {
        setOpen(true);
    }

    const handleClose = (montant) => {
        output(montant);
        setOpen(false);

        if (montant) {
            creditAccount({
                ...montant,
                client: clientId
            }, (err) => {
                output(err);

                notify("Une erreur s'est produite veuillez réessayer!", 'error', 'TOP_CENTER');
            },
                (_client) => {

                    output(_client);
                    setCurrentClient(_client);

                    notify("Le compte a été crédité avec succés!", 'success', 'TOP_RIGHT');
                }


            );
        }
    }

    useEffect(() => {
        // Charger les clients au montage
        console.log('[BFacturation] Chargement initial des clients');
        dispatch(fetchClients({ page: 1, limit: 100 }));

        // Mode transversal si clientId n'est pas fourni
        if (!clientId) {
            console.log('[BFacturation] Mode transversal (Tous les documents)');
            dispatch(fetchFactures());
            dispatch(fetchClientDevis());
            fetchNumberingStats();
            return;
        }

        dispatch(fetchFactures(clientId));

        fetchClient(clientId, (err) => {
            output(err);
        }, (client) => {
            output(client);
            setCurrentClient(client);
        });

        dispatch(fetchClientDevis(clientId));
        fetchNumberingStats();
    }, [clientId, dispatch]);

    // Charger les clients lors de la recherche
    useEffect(() => {
        if (!clientSearchTerm) return;

        const timer = setTimeout(() => {
            console.log('[BFacturation] Recherche clients avec terme:', clientSearchTerm);
            dispatch(fetchClients({ page: 1, nail: clientSearchTerm, criteria: 'nom', limit: 50 }));
        }, 500);

        return () => clearTimeout(timer);
    }, [clientSearchTerm, dispatch]);

    const fetchNumberingStats = async () => {
        setLoadingStats(true);
        try {
            const response = await api.get(`${BaseURL}/public/test/facture-numbering/stats`);
            if (response.data.success) {
                setNumberingStats(response.data.data);
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des statistiques:', error);
            // Données de démonstration en cas d'erreur
            setNumberingStats({
                'FV-2026-03': { prefix: 'FV', year: '2026', month: '03', sequence: 1 },
                'FC-2026-03': { prefix: 'FC', year: '2026', month: '03', sequence: 1 }
            });
        } finally {
            setLoadingStats(false);
        }
    };


    const createFacture = () => {
        const typePath = tab === 0 ? 'factures' : 'devis';
        if (clientId) {
            navigateTo(`/billeterie/${typePath}/nouveau/${clientId}`);
        } else if (currentClient?.id) {
            navigateTo(`/billeterie/${typePath}/nouveau/${currentClient.id}`);
        } else {
            notify("Veuillez d'abord sélectionner un client.", "warning");
        }
    }

    const createFactureComptant = () => {
        navigateTo('/billeterie/factures/nouveau/COMPTANT');
    }

    const handleClientSelect = (event, value) => {
        if (value) {
            setCurrentClient(value);
            navigateTo(`/billeterie/factures/nouveau/${value.id}`);
        }
    };

    const onOptionClicked = (id) => {
        let finalClientId = clientId;
        if (!finalClientId) {
            const facture = factures.find(f => f.id === id);
            finalClientId = facture?.client?.id || facture?.clientId;
        }
        
        if (!finalClientId) {
            notify("Erreur : ID Client introuvable pour cette facture.", "error");
            return;
        }

        const typePath = tab === 0 ? 'factures' : 'devis';
        navigateTo(`/billeterie/${typePath}/${finalClientId}/details/${id}`);
    }

    const onEditClicked = (id) => {
        const facture = factures.find(f => f.id === id);
        let finalClientId = clientId || facture?.client?.id || facture?.clientId;
        
        if (!finalClientId && !facture?.dossier) {
            notify("Erreur : ID Client introuvable pour cette facture.", "error");
            return;
        }

        if (tab === 0) {
            // Facture -> Update
            if (facture?.dossier) {
                // Facture de production
                const dossierId = facture.dossier.id;
                const type = facture.dossier.type || 'circuit';
                navigateTo(`/dossiers/${type}/${dossierId}/factures/${id}/edit`);
            } else {
                // Facture de billetterie
                navigateTo(`/billeterie/facture/${finalClientId}/update/${id}`);
            }
        } else {
            // Devis -> Details (pas de route update spécifique trouvée, on garde details)
            navigateTo(`/billeterie/devis/${finalClientId}/details/${id}`);
        }
    }

    const handleRefresh = () => {
        if (!clientId) {
            dispatch(fetchFactures());
            dispatch(fetchClientDevis());
            fetchNumberingStats();
        } else {
            dispatch(fetchFactures(clientId));
            dispatch(fetchClientDevis(clientId));
        }
    }

    const handleDeleteFacture = async (id) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer cette facture ? Cette action est irréversible.")) {
            try {
                await facturationService.deleteFacture(id);
                notify("Facture supprimée avec succès", "success");
                handleRefresh();
            } catch (err) {
                console.error("Erreur suppression facture:", err);
                notify("Erreur lors de la suppression", "error");
            }
        }
    }

    const filteredFactures = useMemo(() => {
        // Filtrage par type
        let filtered = filtrerParType([...factures], typeFilter);
        
        // Filtrage par terme de recherche
        if (searchTerm) {
            filtered = filtered.filter(facture => 
                (facture.numeroFacture && facture.numeroFacture.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (facture.numeroDossier && facture.numeroDossier.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (facture.commentaire && facture.commentaire.toLowerCase().includes(searchTerm.toLowerCase()))
            );
        }
        
        // Filtrage par statut
        if (statutFilter !== 'ALL') {
            filtered = filtered.filter(facture => 
                facture.statut === statutFilter
            );
        }
        
        return filtered;
    }, [factures, searchTerm, typeFilter, statutFilter]);

    const paginatedFactures = useMemo(() => {
        // S'assurer que le tri par date est appliqué même après filtrage
        const sorted = [...filteredFactures].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        const startIndex = page * rowsPerPage;
        return sorted.slice(startIndex, startIndex + rowsPerPage);
    }, [filteredFactures, page, rowsPerPage]);

    const getTypeColor = (type) => {
        const colors = {
            'BILLETTERIE':  '#1976d2',
            'BILLET_AVION': '#0288d1',
            'MODIFICATION': '#f57c00',
            'ASSURANCE':    '#388e3c',
            'ATTESTATION':  '#7b1fa2',
            'AUTRE':        '#616161',
        };
        return colors[type] || '#616161';
    };

    const getStatutColor = (statut) => {
        const colors = {
            'PAYEE': '#388e3c',
            'IMPAYEE': '#d32f2f',
            'PARTIEL': '#f57c00',
            'ANNULLEE': '#616161'
        };
        return colors[statut] || '#616161';
    };


    return (
        <div className="billeterie-facturation">
            <header className="header-main">
                <IconButton
                    onClick={() => navigateTo(-1)}
                    sx={{ 
                        mr: 1.5,
                        color: COLORS.secondary,
                        bgcolor: 'rgba(0,0,0,0.04)',
                        flexShrink: 0,
                        '&:hover': { bgcolor: 'rgba(0,0,0,0.08)' }
                    }}
                    size="small"
                    aria-label="Retour"
                >
                    <ArrowBack fontSize="small" />
                </IconButton>
                <div className="title-area">
                    <Typography className="title">Journal de Facturation</Typography>
                    <Typography className="subtitle">Consultez et gérez vos documents financiers</Typography>
                </div>
                <div className="top-tabs">
                    <div className={tab === 0 ? "tab-item active" : "tab-item"} onClick={() => setTab(0)}>
                        Factures & Avoirs
                    </div>
                    <div className={tab === 1 ? "tab-item active" : "tab-item"} onClick={() => setTab(1)}>
                        Devis & Pro-forma
                    </div>
                </div>
            </header>

            <section className="hero-section">
                <div className="hero-content">
                    <div className="client-info">
                        <div className="avatar-wrapper">
                            {currentClient && currentClient.structure ?
                                <Business sx={{ color: 'white', fontSize: '2.5rem' }} /> :
                                <AccountBoxSharp sx={{ color: 'white', fontSize: '2.5rem' }} />
                            }
                        </div>
                        <div className="text-info">
                            <Typography className="client-name">
                                {currentClient && (currentClient.prenom ? `${currentClient.prenom} ${currentClient.nom}` : currentClient.nom)}
                            </Typography>
                            <div className="client-meta">
                                <div className="meta-item">
                                    {currentClient?.phone || "Pas de téléphone"}
                                </div>
                                <div className="meta-item">
                                    {currentClient?.ville || "Ville non précisée"}
                                </div>
                            </div>
                            {!clientId && (
                                <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => {
                                        setCurrentClient({});
                                    }}
                                    sx={{ mt: 1, color: COLORS.secondary, fontSize: '0.8rem' }}
                                >
                                    Changer de client
                                </Button>
                            )}
                        </div>
                    </div>

                    <div className="financial-metrics">
                        <div className="metric-card">
                            <Typography className="label">Documents</Typography>
                            <Typography className="value">{filteredFactures.length}</Typography>
                        </div>
                        <div className="metric-card" style={{ background: currentClient?.balance < 0 ? 'rgba(239, 68, 68, 0.2)' : 'rgba(34, 197, 94, 0.2)' }}>
                            <Typography className="label">Solde Compte</Typography>
                            <Typography className="value">{priceFormatterV3(currentClient?.balance || 0)}</Typography>
                        </div>
                    </div>
                </div>
            </section>

            {/* Sélecteur de clients - affiché si aucun client n'est sélectionné */}
            {!clientId && !currentClient?.id && (
                <section className="client-selector-section" style={{ padding: '20px', backgroundColor: 'white', margin: '20px', borderRadius: '10px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                        <Typography variant="h6" sx={{ color: COLORS.secondary }}>
                            Sélectionner un client pour voir ses factures
                        </Typography>
                    </Box>
                    <Autocomplete
                        fullWidth
                        options={clients || []}
                        getOptionLabel={(option) => {
                            const nom = option.nom || '';
                            const prenom = option.prenom || '';
                            const code = option.code ? ` [${option.code}]` : '';
                            return `${nom} ${prenom}${code} (${option.telephone || 'N/A'})`.trim();
                        }}
                        loading={clientsFetchStatus === 'loading'}
                        onInputChange={(event, newInputValue) => {
                            setClientSearchTerm(newInputValue);
                        }}
                        onChange={handleClientSelect}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Rechercher ou sélectionner un client"
                                placeholder="Tapez un nom, prénom ou numéro de téléphone..."
                                variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} />,
                                    endAdornment: (
                                        <React.Fragment>
                                            {clientsFetchStatus === 'loading' ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                        isOptionEqualToValue={(option, val) => (option?.id && val?.id ? option.id === val.id : option === val)}
                        renderOption={(props, option, { index }) => {
                            const { key, ...otherProps } = props;
                            const uniqueKey = option.id || option._id || (option.code ? `client-${option.code}-${index}` : `client-idx-${index}`);
                            return (
                                <li key={uniqueKey} {...otherProps}>
                                    <Box>
                                        <Typography variant="subtitle1" fontWeight="bold">
                                            {option.nom} {option.prenom}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            {option.telephone} - {option.email}
                                        </Typography>
                                    </Box>
                                </li>
                            );
                        }}
                    />
                </section>
            )}

            <div className="action-toolbar">
                <div className="main-actions">
                    <Button
                        onClick={openDialog}
                        variant="contained"
                        startIcon={<MonetizationOnSharp />}
                        sx={{ bgcolor: COLORS.secondary, borderRadius: '10px', px: 3 }}
                    >
                        Créditer Compte
                    </Button>
                    {/* Facture Partenaire : affiché pour les Structures ou si aucun client sélectionné */}
                    {(!currentClient?.id || currentClient?.structure === true) && (
                        <Button
                            onClick={createFacture}
                            variant="outlined"
                            startIcon={<AirplaneTicket />}
                            sx={{ color: COLORS.secondary, borderColor: COLORS.secondary, borderRadius: '10px', px: 3 }}
                        >
                            {tab === 0 ? "Facture Partenaire" : "Devis Partenaire"}
                        </Button>
                    )}
                    {/* Facture Client Comptant : affiché pour les Personnes Physiques ou si aucun client sélectionné */}
                    {(!currentClient?.id || currentClient?.structure === false) && (
                        <Button
                            onClick={createFactureComptant}
                            variant="contained"
                            startIcon={<People />}
                            sx={{ bgcolor: COLORS.tertiary, color: 'white', borderRadius: '10px', px: 3 }}
                        >
                            {tab === 0 ? "Facture Client Comptant" : "Devis Client Comptant"}
                        </Button>
                    )}
                </div>
                
                {loadingStats && <CircularProgress size={24} sx={{ color: COLORS.secondary }} />}
            </div>

            <div className="filter-bar">
                <div className="search-wrapper">
                    <Search>
                        <SearchIconWrapper>
                            <SearchIcon sx={{ color: COLORS.secondary, opacity: 0.7 }} />
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Rechercher par N°, dossier ou motif..."
                            inputProps={{ 'aria-label': 'search' }}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </Search>
                </div>

                {tab === 0 && (
                    <div className="filter-group">
                        <FormControl size="small" sx={{ minWidth: 160 }}>
                            <Select
                                value={typeFilter}
                                onChange={(e) => setTypeFilter(e.target.value)}
                                sx={{ borderRadius: '10px', bgcolor: 'white' }}
                            >
                                {typesFacture.map(t => <MenuItem key={t.value} value={t.value}>{t.label}</MenuItem>)}
                            </Select>
                        </FormControl>

                        <FormControl size="small" sx={{ minWidth: 160 }}>
                            <Select
                                value={statutFilter}
                                onChange={(e) => setStatutFilter(e.target.value)}
                                sx={{ borderRadius: '10px', bgcolor: 'white' }}
                            >
                                {statutsFacture.map(s => <MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </div>
                )}

                <button className="refresh-btn" onClick={handleRefresh}>
                    <Refresh />
                </button>
            </div>

            <main className="content-area">
                {tab === 0 && numberingStats && (
                    <div className="stats-grid">
                        {Object.entries(numberingStats).map(([key, stat]) => (
                            <Box key={key} sx={{ 
                                bgcolor: 'white', p: 2, borderRadius: '12px', borderLeft: `4px solid ${getTypeColor(stat.prefix)}`,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
                            }}>
                                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 700, textTransform: 'uppercase' }}>
                                    {stat.prefix} - Séquence
                                </Typography>
                                <Typography variant="h6" sx={{ color: COLORS.secondary, fontWeight: 800 }}>
                                    #{stat.sequence} <Typography component="span" variant="caption">({stat.month}/{stat.year})</Typography>
                                </Typography>
                            </Box>
                        ))}
                    </div>
                )}

                <div className="table-wrapper">
                    {fetchStatus === 'loading' ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', p: 10 }}>
                            <CircularProgress color="secondary" />
                        </Box>
                    ) : (
                        <>
                            {tab === 0 ? (
                                <StyledTable 
                                    head={head} 
                                    rows={paginatedFactures} 
                                    onOptionClicked={onOptionClicked}
                                    onRowDoubleClick={onEditClicked}
                                    hideOptions={true}
                                    customRenderers={{
                                        'numeroFacture': (value, row) => (
                                            <Typography 
                                                component="span" 
                                                sx={{ color: COLORS.secondary, cursor: 'pointer', textDecoration: 'none', fontWeight: 800, '&:hover': { textDecoration: 'underline' } }}
                                                onClick={(e) => { e.stopPropagation(); onOptionClicked(row.id); }}
                                            >
                                                {value}
                                            </Typography>
                                        ),
                                        'date': (value) => dateFormatter(value),
                                        'type_facture': (value) => (
                                            <Chip
                                                label={value}
                                                size="small"
                                                sx={{ bgcolor: getTypeColor(value), color: 'white', fontWeight: 700, borderRadius: '6px' }}
                                            />
                                        ),
                                        'statut': (value) => (
                                            <Chip
                                                label={value}
                                                size="small"
                                                sx={{ bgcolor: getStatutColor(value), color: 'white', fontWeight: 700, borderRadius: '6px' }}
                                            />
                                        ),
                                        'actions': (value, row) => (
                                            <Stack direction="row" spacing={1}>
                                                <Button
                                                    size="small"
                                                    variant="contained"
                                                    color="secondary"
                                                    startIcon={<Download />}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        const finalClientId = clientId || row?.client?.id || row?.clientId;
                                                        navigateTo(`/billeterie/facture/${finalClientId}/${row.id}/pdf`);
                                                    }}
                                                    sx={{ borderRadius: '6px', fontSize: '0.65rem', py: 0.5 }}
                                                >
                                                    PDF
                                                </Button>
                                                <Tooltip title="Supprimer la facture">
                                                    <span>
                                                        <IconButton 
                                                            size="small" 
                                                            color="error"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleDeleteFacture(row.id);
                                                            }}
                                                            disabled={!isAdmin}
                                                            sx={{ bgcolor: 'rgba(211, 47, 47, 0.08)', '&:hover': { bgcolor: 'rgba(211, 47, 47, 0.15)' } }}
                                                        >
                                                            <Delete fontSize="small" />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            </Stack>
                                        )
                                    }}
                                />
                            ) : (
                                <StyledTable 
                                    head={['numeroDevis', 'createdAt', 'statut']} 
                                    rows={[...devisList].reverse()} 
                                    hideOptions={true}
                                    onOptionClicked={(id) => {
                                        let finalClientId = clientId || devisList.find(d => d.id === id)?.client?.id;
                                        navigateTo(`/billeterie/devis/${finalClientId}/details/${id}`);
                                    }}
                                    customRenderers={{
                                        'numeroDevis': (value, row) => (
                                            <Typography 
                                                component="span" 
                                                sx={{ color: COLORS.secondary, cursor: 'pointer', fontWeight: 800 }}
                                                onClick={(e) => { 
                                                    e.stopPropagation(); 
                                                    let finalClientId = clientId || row?.client?.id;
                                                    navigateTo(`/billeterie/devis/${finalClientId}/details/${row.id}`);
                                                }}
                                            >
                                                {value}
                                            </Typography>
                                        ),
                                        'statut': (value) => (
                                            <Chip
                                                label={value || 'BROUILLON'}
                                                size="small"
                                                sx={{ bgcolor: getStatutColor(value), color: 'white', fontWeight: 700, borderRadius: '6px' }}
                                            />
                                        )
                                    }}
                                />
                            )}
                            
                            <div className="table-pagination-area">
                                <TablePagination
                                    rowsPerPageOptions={[10, 25, 50]}
                                    component="div"
                                    count={filteredFactures.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={(event, newPage) => setPage(newPage)}
                                    onRowsPerPageChange={(event) => {
                                        setRowsPerPage(parseInt(event.target.value, 10));
                                        setPage(0);
                                    }}
                                    labelRowsPerPage="Lignes per page"
                                />
                            </div>
                        </>
                    )}
                </div>
            </main>

            <CreditDialog open={open} onClose={handleClose} />
        </div>
    );


}

export default BFacturation;
